import React, { useEffect, useState } from "react";
import { TableAdv, SmartTooltip } from "../../../components";
import {
  handleLinkedinPostGetAllApi,
  handleLinkedinPostTotalCountApi,
} from "../../../redux/slices/ats/benchSales/benchSalesApi";
import { usePagination } from "../../../hooks";
import { label } from "framer-motion/client";
// import { display } from "html2canvas-pro/dist/types/css/property-descriptors/display";

export default function PostData() {
  const [linkedinPosts, setLinkedinPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    () => {},
  );

  useEffect(() => {
    fetchLinkedinPosts();
    fetchTotalCount();
  }, [page, limit]);

  const fetchTotalCount = async () => {
    try {
      const response = await handleLinkedinPostTotalCountApi({
        coll: "LinkedinPost",
        page: page,
        limit: limit,
      });
      console.log("Total Count:", response);
      setTotalCount(response?.data?.data?.total || 0);
    } catch (error) {
      console.error("Error fetching total count:", error);
    }
  };

  const fetchLinkedinPosts = async () => {
    try {
      setLoading(true);

      const response = await handleLinkedinPostGetAllApi({
        coll: "LinkedinPost",
        page: page,
        limit: limit,
      });

      // adjust based on backend response
      setLinkedinPosts(response?.data?.data || []);
      //   setTotalCount(response?.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching LinkedIn posts:", error);
    } finally {
      setLoading(false);
    }
  };

  //  Transform API data for table
  const tableData = linkedinPosts?.map((item, index) => ({
    id: item?.id || index,
    profileName: item?.profileName,
    profileDesignation: item?.profileDesignation,
    booleanSearch: item?.booleanSearch,
    email: item?.email,
    allEmails: item?.allEmails?.join(", "),
    mobileNumber: item?.mobileNumber,
    source: item?.source,
    dateTime: item?.dateTime,
    displayName: item?.displayName,
  }));

  //  Table columns
  const columns = [
    { key: "displayName", label: "Display Name" },
    { key: "profileName", label: "Profile Name" },

    {
      key: "profileDesignation",
      label: "Profile Designation",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.profileDesignation}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.profileDesignation || "-"}</div>
        </SmartTooltip>
      ),
    },
    // { key: "email", label: "Primary Email" },
    {
      key: "allEmails",
      label: "All Emails",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <div className="line-clamp-1">{row?.allEmails || "-"}</div>
      ),
    },
    { key: "mobileNumber", label: "Mobile" },
    // { key: "source", label: "Source" },
    {
      key: "dateTime",
      label: "Date",
      render: (row) =>
        row?.dateTime ? new Date(row.dateTime).toLocaleString() : "-",
    },
  ];

  return (
    <div>
      <TableAdv
        showSlNo
        columns={columns}
        rows={tableData}
        totalCount={totalCount}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverPagination //
        page={page}
        limit={limit}
        tableId={"linkedinposttable"}
        isLoading={loading}
        isPagination={false} // change if backend supports pagination
        toolbarRight={{
          search: true,
          fullScreen: true,
        }}
      />
    </div>
  );
}
